module.exports = __webpack_public_path__ + "img/logo-9.80434240.png";